var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 9.486c-.93.422-1.92.701-2.953.837a5.241 5.241 0 002.255-2.929c-.991.61-2.085 1.042-3.25 1.283A5.06 5.06 0 0022.308 7c-2.838 0-5.122 2.381-5.122 5.3 0 .42.034.824.119 1.208-4.261-.214-8.032-2.326-10.564-5.542a5.473 5.473 0 00-.702 2.678c0 1.835.914 3.462 2.277 4.404A4.935 4.935 0 016 14.395v.058c0 2.575 1.777 4.714 4.106 5.207a4.957 4.957 0 01-1.343.174c-.329 0-.66-.02-.97-.09.663 2.098 2.548 3.64 4.788 3.69a10.086 10.086 0 01-6.354 2.26c-.42 0-.824-.019-1.227-.072A14.088 14.088 0 0012.863 28c9.43 0 14.587-8.077 14.587-15.078 0-.234-.008-.46-.019-.685A10.423 10.423 0 0030 9.487z",
    fill: "#fff",
    fillRule: "nonzero"
  })));
};

export default __webpack_public_path__ + "static/media/twitter.ac0fb288.svg";
export { SvgTwitter as ReactComponent };